import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProgressProvider } from "@/context/ProgressContext";
import Starfield from "@/components/Starfield";
import CelebrationModal from "@/components/CelebrationModal";
import Dashboard from "@/pages/Dashboard";
import CourseMap from "@/pages/CourseMap";
import LessonView from "@/pages/LessonView";

function App() {
  return (
    <ProgressProvider>
      <div className="min-h-screen bg-[#0B0B15] text-white relative">
        <Starfield />
        <CelebrationModal />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/map" element={<CourseMap />} />
            <Route path="/lesson/:id" element={<LessonView />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ProgressProvider>
  );
}

export default App;
